skrilla.controller('createReferralDefinitionCtrl', function ($scope, searchService, currencyService, promotionService, modalService, cacheService) {
    $scope.user = cacheService.getObjectOrElse("userCustomReferral", function(){modalService.dismissAll();});
    $scope.validate = {}
    $scope.promotion = {
        currency: $scope.user.fiatCurrency
    }

    $scope.save = function() {
        if(promotionService.validatePromotion($scope.promotion, $scope.validate)) {
            modalService.confirm("Are you sure you'd like to create this referral definition?", function () {
                const request = {
                    ...$scope.promotion,
                    ownerAmount: currencyService.multiply($scope.promotion.ownerAmount, $scope.promotion.currency),
                    claimerAmount: currencyService.multiply($scope.promotion.claimerAmount, $scope.promotion.currency)
                }
                searchService.put("users/" + $scope.user.id + "/promotion/customReferral", request, "Referral Successfully created").then(function (response) {
                    modalService.dismissAll();
                }, function (response) {
                    $scope.promotion.ownerAmount = currencyService.divide($scope.promotion.ownerAmount, $scope.promotion.currency)
                    $scope.promotion.claimerAmount = currencyService.divide($scope.promotion.claimerAmount, $scope.promotion.currency)
                })
            });
        }
    }

});